import React from 'react';
import { AddressLink } from '../common/AddressLink';
import { formatDate, formatDateTime, formatNotesWithBullets, getDayOfWeek, formatDateWithDay, getLocationDisplay, getLocationChipColor, getRowAlert, formatDatetimeForInput, parseUTCDatetime, getTodayInAEST, isPrepaymentApproaching, hasAppointments, getAppointmentSummary } from '../../utils/helpers';

const OrderSuccessStep = ({ orderConfirmation, customer, onClose }) => {
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-AU', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <div className="max-w-2xl mx-auto text-center">
      {/* Success Icon */}
      <div className="mb-8">
        <div className="mx-auto flex items-center justify-center h-20 w-20 rounded-full bg-green-100">
          <svg className="h-12 w-12 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        </div>
      </div>

      {/* Success Message */}
      <h3 className="text-2xl font-semibold text-gray-900 mb-4">
        Order Confirmed! 🎉
      </h3>
      <p className="text-gray-600 mb-8">
        Thank you {customer.name}! Your order has been successfully submitted and you'll receive a confirmation email shortly.
      </p>

      {/* Order Details */}
      <div className="bg-gray-50 rounded-lg p-6 mb-8 text-left">
        <h4 className="text-lg font-medium mb-4 text-center">Order Summary</h4>
        <div className="space-y-3">
          <div className="flex justify-between">
            <span className="text-gray-600">Order Number:</span>
            <span className="font-mono font-semibold text-indigo-600">
              {orderConfirmation?.orderNumber}
            </span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-600">Order Date:</span>
            <span>{formatDate(orderConfirmation?.orderDate)}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-600">Items:</span>
            <span>{orderConfirmation?.itemCount} products</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-600">Total Amount:</span>
            <span className="font-semibold text-lg">
              ${orderConfirmation?.totalAmount?.toFixed(2)}
            </span>
          </div>
          <div className="flex justify-between border-t pt-3">
            <span className="text-gray-600">Estimated Delivery:</span>
            <span className="text-green-600 font-medium">
              {formatDate(orderConfirmation?.estimatedDelivery)}
            </span>
          </div>
        </div>
      </div>

      {/* What's Next */}
      <div className="bg-blue-50 rounded-lg p-6 mb-8 text-left">
        <h4 className="text-lg font-medium mb-3 text-blue-900">What happens next?</h4>
        <div className="space-y-2 text-blue-800">
          <p>✅ Order confirmation email sent to {customer.email}</p>
          <p>📦 Your personalized memorial products will be carefully crafted</p>
          <p>🚚 Shipped to: <AddressLink address={customer.address} city={customer.city} state={customer.state} postcode={customer.postcode} testId="confirmation-shipping-address-link" /></p>
          <p>📱 You'll receive tracking information once shipped</p>
        </div>
      </div>

      {/* Action Buttons */}
      <div className="flex flex-col sm:flex-row gap-4 justify-center">
        <button
          onClick={() => {
            // In a real system, this would show order tracking
            alert('Order tracking feature will be available soon. You will receive tracking information via email.');
          }}
          className="px-6 py-3 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg font-medium"
        >
          Track My Order
        </button>
        <button
          onClick={onClose}
          className="px-6 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 font-medium"
        >
          Continue Shopping
        </button>
      </div>

      {/* Contact Information */}
      <div className="mt-8 pt-6 border-t border-gray-200 text-sm text-gray-500">
        <p>Questions about your order?</p>
        <p>Contact us at <a href="mailto:orders@holons.com.au" className="text-indigo-600 hover:underline">orders@holons.com.au</a></p>
        <p>or call <a href="tel:+61234567890" className="text-indigo-600 hover:underline">+61 2 3456 7890</a></p>
      </div>
    </div>
  );
};

// Order History Modal Component

export default OrderSuccessStep;
